import z from "zod";
import { AvailableBillingItemIdScheme } from "./ids";
import { BillingItemType } from "./enums/BillingItemType";
import { MultiCurrencyMoneyScheme } from "./multiCurrencyMoney";
import { Features, isKnownFeature } from "./enums/Features";
import { PaymentProvider } from "./enums/PaymentProvider";

export const BASE_INCLUDED_DEVICES = 1;

export const FeaturesReadScheme = z
  .array(z.unknown())
  .transform((values) => values.filter(isKnownFeature));

export const PricingScheme = z.object({
  monthlyPrice: MultiCurrencyMoneyScheme.optional(),
  oneTimePrice: MultiCurrencyMoneyScheme.optional(),
  prepaid36MonthPrice: MultiCurrencyMoneyScheme.optional(),
});

export const GrantsScheme = z.object({
  features: z.array(z.enum(Features)),
  additionalDevices: z.number().int().min(0),
  paymentTerminals: z.partialRecord(
    z.enum(PaymentProvider),
    z.number().int().min(0),
  ),
});

export const AvailableBillingItemDBScheme = z.object({
  id: AvailableBillingItemIdScheme,
  type: z.enum(BillingItemType),
  name: z.string(),
  description: z.string(),
  bullets: z.array(z.string()).optional(),
  category: z.string().optional(),
  pricing: PricingScheme,
  image: z.string().nullable().optional(),
  comingSoon: z.boolean().optional(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  archivedAt: z.iso.datetime().nullable().optional(),
  features: z.array(z.enum(Features)).nullable().optional(),
  grants: GrantsScheme.optional(),
});

export const RestGetAvailableBillingItem = AvailableBillingItemDBScheme;

export const RestCreateAvailableBillingItem = AvailableBillingItemDBScheme.omit(
  {
    id: true,
    createdAt: true,
    updatedAt: true,
    archivedAt: true,
  },
);

export const RestUpdateAvailableBillingItem = AvailableBillingItemDBScheme.omit(
  {
    id: true,
    createdAt: true,
    updatedAt: true,
    archivedAt: true,
  },
).partial();

export type Grants = z.infer<typeof GrantsScheme>;
export type DBAvailableBillingItem = z.infer<
  typeof AvailableBillingItemDBScheme
>;
export type RestAvailableBillingItem = z.infer<
  typeof RestGetAvailableBillingItem
>;
export type RestCreateAvailableBillingItem = z.infer<
  typeof RestCreateAvailableBillingItem
>;
export type RestUpdateAvailableBillingItem = z.infer<
  typeof RestUpdateAvailableBillingItem
>;
